import { Flex } from '@chakra-ui/react';
import { AddEquipmentPanel } from '../../../equipment/AddEquipmentPanel';
import type { CreateBodyProps } from './createBodyProps';
import { destinationProjectId } from '../destination/createDestination';

/**
 * New equipment: the same flow as the equipment library's Add (options, phone
 * handoff, online search, details form), saved to the chosen destination. On
 * success it opens the new record.
 */
export function EquipmentBody({
  destination,
  onDone,
  onDestinationProblem,
  onBusyChange,
}: CreateBodyProps) {
  return (
    <Flex direction="column" flex={1} minH={0}>
      <AddEquipmentPanel
        parentCollectionId={destinationProjectId(destination)}
        onDone={onDone}
        onDestinationProblem={onDestinationProblem}
        onBusyChange={onBusyChange}
      />
    </Flex>
  );
}
